'use client';

/**
 * LabFlow — Global Error Handler
 * Registers window-level error and unhandledrejection listeners
 * to capture errors that escape React's error boundary.
 *
 * Call initGlobalErrorHandler() once in a client component (e.g. layout).
 */

let initialized = false;

export function initGlobalErrorHandler(): void {
  if (typeof window === 'undefined' || initialized) return;
  initialized = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    import('@/lib/monitoring/sentry')
      .then(({ captureException }) => {
        captureException(event.error ?? new Error(event.message), {
          tags: { layer: 'window_error' },
          extra: {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
          },
        });
      })
      .catch(() => {});
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));

    import('@/lib/monitoring/sentry')
      .then(({ captureException }) => {
        captureException(error, {
          tags: { layer: 'unhandled_promise' },
        });
      })
      .catch(() => {});
  });
}
